import React, { useState, useEffect } from 'react';
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonLabel,
    IonInput,
    IonButton,
    IonItem,
    IonRow,
    IonCol,
    IonFooter,
    useIonAlert,
    IonSelect,
    IonSelectOption, IonIcon,
} from '@ionic/react';

import {
    actionToGetNewsByFilter,
    actionToUploadAdminNewsData,
    actionToUpdateAdminNewsData, actionToGetAllNewsCategoriesAdmin, // 🔹 create/update API
} from "../apiHelpers/CommonAction";
import imageCompression from 'browser-image-compression';
import useStore from "../zustand/useStore";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import {star} from "ionicons/icons";

export default function AddNewsModal({ isOpen, onClose, setIsLoading,dataForEditing }) {
    const { newsCategory,newsDataState } = useStore();
    const { categoryData } = newsCategory;

    const [form, setForm] = useState({
        title: '',
        description: '',
        category_id: '',
        source: '',
        sourceUrl: '',
        image: null,
        pdf: null,
    });

    const [errors, setErrors] = useState({});
    const [presentAlert] = useIonAlert();

    const { resetNewsLetterFilters } = useStore();

    // 🔹 Prefill form if editing
    useEffect(() => {
        if (dataForEditing?.id) {
            setForm({
                title: dataForEditing.title || '',
                description: dataForEditing.description || '',
                category_id: dataForEditing.category_id || '',
                source: dataForEditing.source || '',
                sourceUrl: dataForEditing.source_url || '',
                image: null, // keep null unless user uploads new one
                pdf: null,   // keep null unless user uploads new one
            });
        }
    }, [dataForEditing, isOpen]);

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1200,
            useWebWorker: true,
        };

        try {
            const compressedBlob = await imageCompression(file, options);

            // wrap into File (important!)
            const compressedFile = new File([compressedBlob], file.name, {
                type: compressedBlob.type,
                lastModified: Date.now(),
            });

            handleChange('image', compressedFile);
        } catch (error) {
            console.error("Image compression error:", error);
        }
    };

    const validate = () => {
        const newErrors = {};
        if (!form.title) newErrors.title = 'Title is required';
        if (!form.description) newErrors.description = 'Description is required';
        if (!form.category_id) newErrors.category_id = 'Category is required';
        if (!form.source) newErrors.source = 'Source is required';

        // If adding → require image/pdf
        if (!dataForEditing?.id) {
            if (!form.image) newErrors.image = 'Image is required';
        }

        return newErrors;
    };

    const handleSubmit = () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setIsLoading(true);

        const formData = new FormData();
        formData.append('title', form.title);
        formData.append('description', form.description);
        formData.append('category_id', form.category_id);
        formData.append('source', form.source);
        formData.append('source_url', form.sourceUrl);
        if(dataForEditing?.id){
            formData.append('id', dataForEditing?.id);
        }

        if (form.image) formData.append('image', form.image);
        if (form.pdf) formData.append('attachment', form.pdf);

        // 🔹 Check if edit or add
        const apiCall = dataForEditing?.id
            ? actionToUpdateAdminNewsData(formData) // update
            : actionToUploadAdminNewsData(formData);             // add

        apiCall
            .then(() => {
                setIsLoading(false);
                resetNewsLetterFilters();
                if(dataForEditing?.id){
                    actionToGetNewsByFilter(false,{offset:newsDataState?.offset});
                }else{
                    actionToGetNewsByFilter();
                }

                closeAndResetFile();
            })
            .catch(() => {
                setIsLoading(false);
                presentAlert({
                    message: 'Something went wrong while saving news.',
                    buttons: ['OK'],
                });
            });
    };

    const closeAndResetFile = () =>{
        setErrors({})
        onClose();
        setForm({
            title: '',
            description: '',
            category_id: '',
            source: '',
            sourceUrl: '',
            image: null,
            pdf: null,
        })
    }


    useEffect(() => {
        actionToGetAllNewsCategoriesAdmin();
    }, []);


    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={closeAndResetFile}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonTitle>{dataForEditing?.id ? "Edit News" : "Add News"}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding bottom-2 no_padding_top">
                <div className="rfp_submit_form">

                    {/* Title */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Title<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            className="rfp_form_input"
                            placeholder="Enter news title"
                            value={form.title}
                            onIonInput={(e) => handleChange('title', e.detail.value)}
                        />
                        {errors.title && <p className="error-text">{errors.title}</p>}
                    </div>

                    {/* Description */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Description<IonIcon icon={star} className="required-star" /></IonLabel>
                        <ReactQuill
                            theme="snow"
                            className={"react_quill_in_news"}
                            value={form.description}
                            onChange={(value) => handleChange('description', value)}
                            modules={{
                                toolbar: [
                                    ['bold', 'italic', 'underline'],
                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                    [
                                        { align: '' }, { align: 'center' },
                                        { align: 'right' }, { align: 'justify' }
                                    ],
                                    ['clean']
                                ]
                            }}
                            style={{ backgroundColor: 'white' }}
                        />
                        {errors.description && <p className="error-text">{errors.description}</p>}
                    </div>

                    {/* Category */}
                    <div className="rfp_submit_form_item">
                        <IonLabel>Category<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonSelect
                            className="rfp_form_input"
                            value={form.category_id}
                            placeholder="Select category"
                            onIonChange={(e) => handleChange('category_id', e.detail.value)}
                        >
                            {categoryData.map((cat) => (
                                <IonSelectOption key={cat?.id} value={cat?.id}>
                                    {cat?.name?.replace(/-/g, " ")?.replace(/\b\w/g, l => l.toUpperCase())}
                                </IonSelectOption>
                            ))}
                        </IonSelect>
                        {errors.category_id && <p className="error-text">{errors.category_id}</p>}
                    </div>

                    {/* Source */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Source<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonInput
                            className="rfp_form_input"
                            placeholder="Enter news source"
                            value={form.source}
                            onIonInput={(e) => handleChange('source', e.detail.value)}
                        />
                        {errors.source && <p className="error-text">{errors.source}</p>}
                    </div>

                    {/* Source URL */}
                    <div className="rfp_submit_form_item">
                        <IonLabel position="floating">Source URL</IonLabel>
                        <IonInput
                            className="rfp_form_input"
                            placeholder="Enter source URL"
                            value={form.sourceUrl}
                            onIonInput={(e) => handleChange('sourceUrl', e.detail.value)}
                        />
                        {errors.sourceUrl && <p className="error-text">{errors.sourceUrl}</p>}
                    </div>

                    {/* Image Upload */}
                    <div className="rfp_submit_form_item">
                        <IonLabel>News Poster (Image)<IonIcon icon={star} className="required-star" /></IonLabel>
                        <IonItem className="ion-no-padding ion-margin-bottom">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleImageUpload(e)}
                            />
                        </IonItem>
                        {dataForEditing?.id && !form.image && (
                            <small>Current: {dataForEditing.image_url}</small>
                        )}
                        {errors.image && <p className="error-text">{errors.image}</p>}
                    </div>

                    {/* PDF Upload */}
                    <div className="rfp_submit_form_item">
                        <IonLabel>Attach PDF</IonLabel>
                        <IonItem className="ion-no-padding ion-margin-bottom">
                            <input
                                type="file"
                                accept="application/pdf"
                                onChange={(e) => handleChange('pdf', e.target.files[0])}
                            />
                        </IonItem>
                        {dataForEditing?.id && !form.pdf && dataForEditing.attachment_url && (
                            <small>Current: {dataForEditing.attachment_url}</small>
                        )}
                        {errors.pdf && <p className="error-text">{errors.pdf}</p>}
                    </div>
                </div>
            </IonContent>

            <IonFooter className="job_detail_sheet_footer ion-padding">
                <IonToolbar>
                <IonRow>
                    <IonCol>
                        <IonButton className="close_job_detail_button" expand="block" onClick={closeAndResetFile}>
                            Close
                        </IonButton>
                    </IonCol>
                    <IonCol>
                        <IonButton className="apply_job_button" expand="block" onClick={handleSubmit}>
                            {dataForEditing?.id ? "Update News" : "Submit News"}
                        </IonButton>
                    </IonCol>
                </IonRow>
                </IonToolbar>
            </IonFooter>
        </IonModal>
    );
}
